const DATA = {
  title: "Reading Room Dubai",
  items: [
    {
      title: "Macroeconomic and Geopolitical views",
      items: [
        {
          name: "What Trump’s Tariff Critics Are Getting Wrong",
          link: "https://www.project-syndicate.org/commentary/democrats-misguided-criticism-of-trump-tariffs-by-lori-wallach-2025-03",
          description:
            "Lori Wallach, Director of the Rethink Trade program at the American Economic Liberties Project writes that US President Donald Trump’s focus on “reciprocal tariffs does not suggest that his administration intends to use tariffs strategically to cut the country’s chronic trade deficit, but that tariffs will be part of the fix.",
        },
        {
          name: "Reciprocity and discrimination: When are tariffs useful remedies?",
          description: `Kimberly Clausing, Senior Researcher, Peterson Institute of International Economics writes about the US administration invoking "reciprocity" in at least four areas and why it is not a good response.`,
          link: "https://www.piie.com/blogs/realtime-economics/2025/reciprocity-and-discrimination-when-are-tariffs-useful-remedies",
        },
        {
          name: "Will the world trading system survive Trump’s tariffs?",
          description:
            "Alan Wm. Wolff, Senior Researcher, Peterson Institute of International Economics writes about how world trade will adapt to American trade restrictiveness.",
          link: "https://www.piie.com/blogs/realtime-economics/2025/will-world-trading-system-survive-trumps-tariffs",
        },
        {
          name: "MENA Outlook 2025",
          description: "Middle East Council of Global Affairs",
          link: "https://mecouncil.org/blog_posts/mena-outlook-for-2025/",
        },
        {
          name: "U.S. Forces in the Middle East: Mapping the Military Presence",
          description:
            "Jonathan Masters and Will Merrow write for the Council of Foreign Relations on US activities and military agreements in the Middle East.",
          link: "https://www.cfr.org/article/us-forces-middle-east-mapping-military-presence",
        },
        {
          name: "US allies question extended deterrence guarantees, but have few options",
          description:
            "Zuzanna Gwadera, Research Analyst and Programme Administrator, International Institute of Strategic Studies (IISS)",
          link: "https://www.iiss.org/online-analysis/military-balance/2025/03/us-allies-question-extended-deterrence-guarantees-but-have-few-options/",
        },
        {
          name: "OECD Economic Outlook, Interim Report March 2025",
          link: "https://www.oecd.org/en/publications/oecd-economic-outlook-interim-report-march-2025_89af4857-en.html",
        },
      ],
    },
    {
      title: "Fixed Income",
      items: [
        {
          name: "Will the World Keep Buying US Treasuries?",
          description:
            "Paola Subacchi, Professor and Chair in Sovereign Debt at Sciences Po and Paul van den Noord, Affiliate Member in the Amsterdam School of Economics at the University of Amsterdam. They argue that the US dollar will remain world’s key international currency only if US institutions remain strong and credible enough to preserve confidence in Treasuries.",
          link: "https://www.project-syndicate.org/commentary/implications-of-falling-demand-for-us-treasuries-by-paola-subacchi-and-paul-van-den-noord-2025-03",
        },
      ],
    },
    {
      title: "Stocks and ETFs",
      items: [
        {
          name: "Is This Really How American Exceptionalism Ends?",
          description:
            "Alison Schrager writes for Bloomberg about the uncertainty around trade and the future strength of the dollar leading investors to retreat from American stocks and that the problem may go deeper.",
          link: "https://www.bloomberg.com/opinion/articles/2025-03-31/american-exceptionalism-may-prove-ephemeral",
        },
      ],
    },
    {
      title: "Commodities",
      items: [
        {
          name: "Trump 2.0 and Oil Markets",
          description:
            "Bassam Fattouh and Andreas Economou at the Oxford Institute for Energy Studies discuss new energy executive orders, the impact of Trump 2.0 on oil markets and oil trade flows, increasing sanctions on Iran and Russia, and the changing relationship with OPEC.",
          link: "https://www.oxfordenergy.org/wpcms/wp-content/uploads/2025/03/OIES-Presentation-Trump-2.0-and-Oil-Markets-March-2025.pdf",
        },
        {
          name: "5 trends shaping the energy world in 2025",
          description:
            "Simon Flowers, Chairman and Chief Analyst, Wood Mackenzie writes for the World Economic Forum about the five key things he sees happening in energy markets.",
          link: "https://www.weforum.org/stories/2025/03/5-energy-trends-2025/",
        },
        {
          name: "How Trump’s new energy policies reshape global oil markets",
          description:
            "Dr Elif Selin Calik writing for Middle East Monitor reviews the use of sanctions and US fossil-fuel favouritism.",
          link: "https://www.middleeastmonitor.com/20250328-how-trumps-new-energy-policies-reshape-global-oil-markets/",
        },
        {
          name: "Oil markets face uncertainty amid changing geopolitics",
          link: "https://www.gisreportsonline.com/r/global-oil-market/",
        },
        {
          name: "Gulf petrostate Kuwait tries to kick-start diversification from oil",
          description:
            "Chloe Cornish writing for the Financial Times about how Kuwait is hitting up debt markets to finance its diversification efforts but that it has no intention of backing away from fossil fuels.",
          link: "https://www.ft.com/content/5474653f-d48b-4199-a695-f39df1a8f368",
        },
        {
          name: "The 2025 Global Energy Agenda",
          description: "The Atlantic Council Global Energy Centre",
          link: "https://www.atlanticcouncil.org/wp-content/uploads/2025/02/The-2025-Global-Energy-Agenda.pdf",
        },
        {
          name: "You asked, we answered: Gold hits $3,000 – What comes next?",
          description:
            "Taylor Burnette, Research Lead for the World Gold Council writes about gold’s move above the psychologically important $3,000 level and why it will stay high.",
          link: "https://www.gold.org/goldhub/gold-focus/2025/03/you-asked-we-answered-gold-hits-3000-what-comes-next#:~:text=Chart%202%3A%20Gold's%20recent%20move,divergence%20above%20its%20moving%20average&text=*Based%20on%20spot%20gold%20(XAU,spot%20price%20and%20its%20200DMA.",
        },
      ],
    },
    {
      title: "Cryptocurrencies and Digital Asset Development",
      items: [
        {
          name: "The sane person’s guide to crypto investing",
          description:
            "Jeff John Roberts writes for Fortune Crypto on the tactics crypto investors may take.",
          link: "https://fortune.com/crypto/2025/03/27/cryptocurrency-investing-bitcoin-dogecoin-guide/",
        },
        {
          name: "Basel cryptoasset rules are too obstructive",
          description:
            "Lewis McLellan, Editor, Digital Monetary Institute at OMFIF, and Marcelo Prates is Policy Director at Stellar Development Foundation write on Distributed Ledger Technology and the Basel Committee’s rules on prudential exposure to cryptoassets.",
          link: "https://www.omfif.org/2025/03/eurosystem-cash-solution-for-dlt-transactions-a-start-but-not-enough/",
        },
        {
          name: "As Crypto Market Matures, What's Next for Bitcoin, Ether and Solana?",
          description:
            "Erik Norland writes for CME Group on what’s been driving Bitcoin and other cryptocurrencies lower, including the degree of correlation between them and other asset classes.",
          link: "https://www.cmegroup.com/insights/economic-research/2025/as-crypto-market-matures-whats-next-for-bitcoin-ether-and-solana.html",
        },
      ],
    },
  ],
}

export default DATA
